/* tslint:disable */
/* eslint-disable */
/**
 * Cushla API
 * REST API for Cushla
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * If data was generated by patient (MANUAL), from a PDF (PARSED) or by something/someone else (IMPORTED)
 * @export
 * @enum {string}
 */

export enum DataOrigin {
  MANUAL = 'MANUAL',
  PARSED = 'PARSED',
  IMPORTED = 'IMPORTED',
}
